import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component'
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import {TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';

import { IntuitiveComponent } from './intuitive/intuitive.component';
import { TIntuitiveComponent } from './t-intuitive/t-intuitive.component';

import { DistancesComponent } from './distances/distances.component';
import { TDistancesComponent } from './t-distances/t-distances.component';

import { CreateCodesComponent } from './create-codes/create-codes.component';
import { TCreateCodesComponent } from './t-create-codes/t-create-codes.component';

import { CtComputeBitsComponent } from './ct-compute-bits/ct-compute-bits.component';
import { TCtComputeBitsComponent } from './t-ct-compute-bits/t-ct-compute-bits.component';

import { ReverseBitComponent } from './reverse-bit/reverse-bit.component';
import { TReverseBitComponent } from './t-reverse-bit/t-reverse-bit.component';

import { ModuloComponent } from './modulo/modulo.component';
import { TModuloComponent } from './t-modulo/t-modulo.component';

import{ ExampleComponent } from './example/example.component';
import{ TExampleComponent } from './t-example/t-example.component';


import {PlaygroundComponent } from './playground/playground.component';




const selfCorrectingRoutes: Routes = [
  { path: 'selfcorrecting', component:TopicComponent,
  children : [
    { path: '', component: ExercisesComponent, pathMatch: 'full'},
    { path: 'exam/:id', component: ExamComponent},
    { path: 'exam/:id/evaluation', component: EvaluationComponent},
    { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent}, 
    { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent},
    { path: 'openQuestion/:id', component: OpenQuestionComponent}, 
    { path: 'multipleChoice/:id', component: MultipleChoiceComponent},
    { path: 'playground', component: PlaygroundComponent},
   
   { path: 'intuitive/:id', component: IntuitiveComponent},
   { path: 'exam/:examid/intuitive/:id', component: IntuitiveComponent},

   { path: 'distances/:id', component: DistancesComponent},
   { path: 'exam/:examid/distances/:id', component: DistancesComponent},

   { path: 'createCodes/:id', component: CreateCodesComponent},
   { path: 'exam/:examid/createCodes/:id', component: CreateCodesComponent},

   { path: 'controlBits/:id', component: CtComputeBitsComponent},
   { path: 'exam/:examid/controlBits/:id', component: CtComputeBitsComponent},

   { path: 'reverseBit/:id', component: ReverseBitComponent},
   { path: 'exam/:examid/reverseBit/:id', component: ReverseBitComponent},

   { path: 'modulo/:id', component: ModuloComponent},
   { path: 'exam/:examid/modulo/:id', component: ModuloComponent},

   { path: 'example/:id', component: ExampleComponent},
   { path: 'exam/:examid/example/:id', component: ExampleComponent},
    

  ] },
  {path: 'teacher/selfcorrecting', canActivate: [TeacherGuard], canActivateChild:[TeacherGuard], component: TopicComponent,
    children:[
    { path: '', component: TExercisesComponent, pathMatch: 'full'},
    { path: 'openQuestion', component: TOpenQuestionComponent}, 
    { path: 'multipleChoice', component: TMultipleChoiceComponent},
    { path: 'openQuestion/:id', component: TOpenQuestionComponent}, 
    { path: 'multipleChoice/:id', component: TMultipleChoiceComponent},
    { path: 'allExercisesTeacher', component: TAllExercisesComponent},
    { path: 'allExamsTeacher', component: TAllExamsComponent},
    
   { path: 'intuitive', component: TIntuitiveComponent},
   { path: 'intuitive/:id', component: TIntuitiveComponent},
   
   { path: 'distances', component: TDistancesComponent},
   { path: 'distances/:id', component: TDistancesComponent},
   
   { path: 'createCodes', component: TCreateCodesComponent},
   { path: 'createCodes/:id', component: TCreateCodesComponent},
   
   { path: 'controlBits', component: TCtComputeBitsComponent},
   { path: 'controlBits/:id', component: TCtComputeBitsComponent},
   
   { path: 'reverseBit', component: TReverseBitComponent},
   { path: 'reverseBit/:id', component: TReverseBitComponent},
   
   { path: 'modulo', component: TModuloComponent},
   { path: 'modulo/:id', component: TModuloComponent},
   
   { path: 'example', component: TExampleComponent},
   { path: 'example/:id', component: TExampleComponent},


    { path: 'exam', component: TExamComponent},
    { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full'},
      { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent},
      { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent},
      { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent},
      { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent},
      
      { path: 'exam/:examid/intuitive', component: TIntuitiveComponent},
      { path: 'exam/:examid/intuitive/:id', component: TIntuitiveComponent},
      
      { path: 'exam/:examid/distances', component: TDistancesComponent},
      { path: 'exam/:examid/distances/:id', component: TDistancesComponent},

      { path: 'exam/:examid/createCodes', component: TCreateCodesComponent},
      { path: 'exam/:examid/createCodes/:id', component: TCreateCodesComponent},

      { path: 'exam/:examid/controlBits', component: TCtComputeBitsComponent},
      { path: 'exam/:examid/controlBits/:id', component: TCtComputeBitsComponent},

      { path: 'exam/:examid/reverseBit', component: TReverseBitComponent},
      { path: 'exam/:examid/reverseBit/:id', component: TReverseBitComponent},

      { path: 'exam/:examid/modulo', component: TModuloComponent},
      { path: 'exam/:examid/modulo/:id', component: TModuloComponent},

      { path: 'exam/:examid/example', component: TExampleComponent},
      { path: 'exam/:examid/example/:id', component: TExampleComponent},

  ] }
];

@NgModule({
  imports: [
      RouterModule.forChild(selfCorrectingRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
